enum LocalStorageKey {
	CONFIG_KEY = 'PWA_CONFIG',
	REGISTRATION_ID = 'notification-registration-id',
	IS_SUBSCRIBED = 'notification-is-subscribed',
	EXPAND_MAINTENANCE_NOTICE = 'expand-maintenance-notice',
}

enum SessionStorageKey {
	HIDE_INSTALL = 'install-prompt-hidden',
	HIDE_NOTI_PROMPT = 'notification-prompt-hidden',
	HIDE_INTERMEDIARY_SCREEN = 'intermediary-screen-hidden',
}

enum BooleanString {
	TRUE = 'true',
	FALSE = 'false',
}

export { LocalStorageKey, SessionStorageKey, BooleanString };
